(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["becquer-top-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.bqtbInit) return;
    root.dataset.bqtbInit = '1';

    if (root.getAttribute('data-timer') === 'true') {
      var mode = root.getAttribute('data-mode');
      var hours = parseInt(root.getAttribute('data-hours'), 10) || 6;
      var hEl = root.querySelector('[data-h]'), mEl = root.querySelector('[data-m]'), sEl = root.querySelector('[data-s]');
      var prog = root.querySelector('[data-progress]');
      var p2 = function (n) { return ('0' + n).slice(-2); };
      var tick = function () {
        var now = Date.now(), remaining, total;
        if (mode === 'loop') { total = hours * 3600; var sec = Math.floor(now / 1000); remaining = total - (sec % total); }
        else { var d = new Date(); var end = new Date(d.getFullYear(), d.getMonth(), d.getDate() + 1, 0, 0, 0, 0); remaining = Math.floor((end - d) / 1000); total = 24 * 3600; }
        var h = Math.floor(remaining / 3600), m = Math.floor((remaining % 3600) / 60), s = remaining % 60;
        if (hEl) hEl.textContent = p2(h);
        if (mEl) mEl.textContent = p2(m);
        if (sEl) sEl.textContent = p2(s);
        if (prog) prog.style.width = (remaining / total * 100).toFixed(2) + '%';
      };
      tick();
      setInterval(tick, 1000);
    }

    var btn = root.querySelector('[data-coupon]');
    if (btn) {
      btn.addEventListener('click', function () {
        var code = btn.getAttribute('data-code') || '';
        var lbl = btn.querySelector('[data-copy-label]');
        var old = lbl ? lbl.textContent : '';
        var done = function () { btn.classList.add('ok'); if (lbl) lbl.textContent = 'copiado \u2713'; setTimeout(function () { btn.classList.remove('ok'); if (lbl) lbl.textContent = old; }, 1600); };
        try { navigator.clipboard.writeText(code).then(done, done); }
        catch (e) { var t = document.createElement('textarea'); t.value = code; document.body.appendChild(t); t.select(); try { document.execCommand('copy'); } catch (e2) {} document.body.removeChild(t); done(); }
      });
    }
  }
  document.querySelectorAll('.bqtb').forEach(init);
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.bqtb'); if (el) init(el);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq-becquer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.bqf').forEach(function(root){
      if(root.dataset.bqfReady) return; root.dataset.bqfReady='1';
      var accEl=root.querySelector('[data-bqf-acc]');
      var tabsEl=root.querySelector('[data-bqf-tabs]');
      var moreEl=root.querySelector('[data-bqf-more]');
      var items=[].slice.call(accEl.querySelectorAll('[data-bqf-item]'));
      if(!items.length){ return; }

      // categorias na ordem de aparição
      var CATS=[];
      items.forEach(function(it){ var c=it.getAttribute('data-cat')||'Geral'; if(CATS.indexOf(c)<0) CATS.push(c); });

      var filter=-1, expanded=false;

      function apply(){
        var collapsed=(filter===-1 && !expanded), hidden=0;
        items.forEach(function(it){
          var cat=it.getAttribute('data-cat')||'Geral';
          var imp=it.getAttribute('data-imp')==='1';
          var visible = filter===-1 ? (collapsed ? imp : true) : (cat===CATS[filter]);
          if(!visible) hidden++;
          it.classList.toggle('hide', !visible);
        });
        // tabs
        var tabs=['<button class="bqf-tab'+(filter===-1?' on':'')+'" data-f="-1">Todas</button>'];
        CATS.forEach(function(c,i){ tabs.push('<button class="bqf-tab'+(filter===i?' on':'')+'" data-f="'+i+'">'+c+'</button>'); });
        tabsEl.innerHTML=tabs.join('');
        tabsEl.querySelectorAll('.bqf-tab').forEach(function(t){ t.onclick=function(){ filter=+t.getAttribute('data-f'); expanded=false; apply(); }; });
        // ver mais
        if(collapsed && hidden>0){
          moreEl.innerHTML='<button>Ver mais perguntas ('+hidden+')</button>';
          moreEl.querySelector('button').onclick=function(){ expanded=true; apply(); };
        } else moreEl.innerHTML='';
      }

      items.forEach(function(it){ it.querySelector('.bqf-q').onclick=function(){ it.classList.toggle('open'); }; });
      apply();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-hero-becquer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.ghero').forEach(function(root){
      if(root.dataset.gheroReady) return; root.dataset.gheroReady='1';
      var layers = root.querySelectorAll('[data-ghero-layer]');
      var items = root.querySelectorAll('[data-ghero-item]');
      var isTouch = window.matchMedia('(hover: none)').matches;

      function activate(i){
        layers.forEach(function(l,li){
          var on = li===i;
          l.classList.toggle('on', on);
          if(on){ l.querySelectorAll('video').forEach(function(v){ if(!v.src && v.dataset.src) v.src=v.dataset.src; var p=v.play(); if(p&&p.catch)p.catch(function(){}); }); }
        });
        items.forEach(function(it,ii){ it.classList.toggle('on', ii===i); });
      }

      items.forEach(function(it,i){
        if(!isTouch){
          it.addEventListener('mouseenter', function(){ activate(i); });
          it.addEventListener('focus', function(){ activate(i); });
        }
        it.addEventListener('click', function(e){
          var href = it.getAttribute('data-href');
          if(it.classList.contains('on') && href){ window.location.href = href; return; }
          activate(i);
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quem-usa-becquer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    document.querySelectorAll('.bqu-slider').forEach(function(s){
      if(s.dataset.bquReady) return; s.dataset.bquReady='1';
      var fill = s.parentNode.querySelector('[data-bqu-fill]');
      function upd(){ if(!fill)return; var max=s.scrollWidth-s.clientWidth; var p=max>0?s.scrollLeft/max:0; var vis=s.clientWidth/s.scrollWidth; var w=Math.max(.12,vis); fill.style.width=(w*100)+'%'; fill.style.left=(p*(100-w*100))+'%'; }
      s.addEventListener('scroll',upd); window.addEventListener('resize',upd); upd();

      var down=false,sx,sl,moved=false;
      s.addEventListener('pointerdown',function(e){down=true;moved=false;s.classList.add('drag');sx=e.pageX;sl=s.scrollLeft;});
      window.addEventListener('pointerup',function(){down=false;setTimeout(function(){s.classList.remove('drag');},0);});
      window.addEventListener('pointermove',function(e){if(!down)return;if(Math.abs(e.pageX-sx)>4)moved=true;s.scrollLeft=sl-(e.pageX-sx);});

      var frames=[].slice.call(s.querySelectorAll('[data-bqu-v]'));
      if('IntersectionObserver' in window){
        var io=new IntersectionObserver(function(es){
          es.forEach(function(en){ var v=en.target.querySelector('video'); if(!v)return; if(en.isIntersecting){ var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){}); } else { v.pause(); } });
        },{threshold:.25});
        frames.forEach(function(f){ io.observe(f); });
      }
      function muteAll(except){ frames.forEach(function(f){ if(f!==except){ f.classList.remove('on'); var v=f.querySelector('video'); if(v)v.muted=true; } }); }
      frames.forEach(function(f){
        f.addEventListener('click',function(){
          if(moved)return;
          var v=f.querySelector('video'); if(!v)return;
          if(f.classList.contains('on')){ f.classList.remove('on'); v.muted=true; }
          else{ muteAll(f); f.classList.add('on'); v.muted=false; var pr=v.play(); if(pr&&pr.catch)pr.catch(function(){}); }
        });
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews-becquer"] && !Shopify.designMode) return;
  try {
    
  (function(){
    var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function setup(track){
      if(track.dataset.bqrReady) return; track.dataset.bqrReady='1';
      var scrollEl = track.parentNode;
      var mq = scrollEl.closest('.bqr-mq');
      if(!track.children.length) return;

      var original = track.innerHTML;
      var guard = 0;
      while(track.scrollWidth < scrollEl.clientWidth*1.2 && guard<20){ track.insertAdjacentHTML('beforeend', original); guard++; }
      var half = track.scrollWidth;
      track.insertAdjacentHTML('beforeend', track.innerHTML);

      var speed = parseFloat(getComputedStyle(track.closest('.bqr')).getPropertyValue('--bqr-speed')) || 60;
      var paused = reduceMotion;
      var resumeTimer = null;
      var lastTs = null;

      function pause(){
        paused = true;
        if(resumeTimer){ clearTimeout(resumeTimer); resumeTimer = null; }
      }
      function scheduleResume(delay){
        if(reduceMotion) return;
        if(resumeTimer) clearTimeout(resumeTimer);
        resumeTimer = setTimeout(function(){ paused = false; resumeTimer = null; }, delay);
      }

      function frame(ts){
        if(lastTs === null) lastTs = ts;
        var dt = (ts - lastTs) / 1000;
        lastTs = ts;
        if(!paused){
          scrollEl.scrollLeft += speed * dt;
          if(scrollEl.scrollLeft >= half) scrollEl.scrollLeft -= half;
        }
        requestAnimationFrame(frame);
      }
      requestAnimationFrame(frame);

      scrollEl.addEventListener('pointerdown', pause, {passive:true});
      scrollEl.addEventListener('pointerup', function(){ scheduleResume(1200); }, {passive:true});
      scrollEl.addEventListener('pointercancel', function(){ scheduleResume(1200); }, {passive:true});
      scrollEl.addEventListener('mouseenter', pause);
      scrollEl.addEventListener('mouseleave', function(){ scheduleResume(300); });

      var prevBtn = mq.querySelector('[data-bqr-prev]');
      var nextBtn = mq.querySelector('[data-bqr-next]');
      function nudge(dir, e){
        if(e) e.stopPropagation();
        pause();
        var first = track.querySelector('.bqr-card');
        var cardW = first ? first.getBoundingClientRect().width + 16 : 276;
        scrollEl.scrollBy({ left: dir * cardW, behavior:'smooth' });
        scheduleResume(1800);
      }
      if(prevBtn) prevBtn.addEventListener('click', function(e){ nudge(-1, e); });
      if(nextBtn) nextBtn.addEventListener('click', function(e){ nudge(1, e); });
    }

    document.querySelectorAll('[data-bqr-track]').forEach(function(t){
      if(document.readyState==='complete') setup(t);
      else window.addEventListener('load', function(){ setup(t); });
      setTimeout(function(){ if(!t.dataset.bqrReady) setup(t); }, 1200);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
